import { Link, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import RemedyTable from "./viewTable/RemedyTable";
import ConsultantHistoryTable from "./viewTable/ConsultantHistoryTable";
import ModalBox from "../../components/modal/ModalBox";
import {
  getNumericalAnalyticsApi,
} from "../../services/userManagement";
import scrollToUp from "../../utils/scrollToUp";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";
import { Paper, Typography } from "@mui/material";
import { CustomTab } from "../../components/tabs/Tabs";
import useResponsive from "../../hooks/useResponsive";
import ResponsiveAnalytics from "../../components/ResponsiveAnalytics";

const NumericalAnalytics = () => {
  const { id: userId } = useParams();
  const [analyticsData, setAnalyticsData] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  // Fetch numerical analytics data
  const fetchNumericalAnalytics = async (userId) => {
    try {
      showLoader();
      const sendData = { userId };
      const { data } = await getNumericalAnalyticsApi(sendData);
      if (data?.code === 200) {
        setAnalyticsData(data?.result || {});
      } else {
        setAnalyticsData({});
        toastMessage(data?.message, "error", "numericalAnalytics");
      }
    } catch (error) {
      console.error("Error fetching numerical analytics:", error);
      toastMessage("Failed to fetch analytics data", "error", "numericalAnalytics");
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (userId) {
      fetchNumericalAnalytics(userId);
    }
  }, [userId]);

  // Format number for display
  const formatNumber = (value) => (value ? Number(value).toFixed(2) : "0.00");

  // Analytics data configuration
  const analyticsCards = [
    {
      title: "Total Consultations",
      value: analyticsData.totalNumberOfConsultations || 0,
      type: "number"
    },
    {
      title: "Chat Consultations",
      value: analyticsData.totalConsultationsViaChat || 0,
      type: "number"
    },
    {
      title: "Call Consultations",
      value: analyticsData.totalConsultationsViaCall || 0,
      type: "number"
    },
    {
      title: "Users in Waiting List",
      value: analyticsData.usersInWaitingList || 0,
      type: "number"
    },
    {
      title: "Total Amount Spent",
      value: (
        (analyticsData.totalSpendingOnChatConsultations || 0) +
        (analyticsData.totalSpendingOnCallConsultations || 0) +
        (analyticsData.totalSpendingOnVideoConsultations || 0)
      ).toFixed(2),
      type: "currency"
    },
    {
      title: "Spending on Chat",
      value: (analyticsData.totalSpendingOnChatConsultations || 0).toFixed(2),
      type: "currency"
    },
    {
      title: "Spending on Call",
      value: (analyticsData.totalSpendingOnCallConsultations || 0).toFixed(2),
      type: "currency"
    },
    {
      title: "Total Gifts Sent",
      value: formatNumber(analyticsData.totalGiftsSentToConsultants) || 0,
      type: "number"
    },
    {
      title: "Wallet Balance",
      value: formatNumber(analyticsData?.currentWalletBalance) || 0,
      type: "currency"
    },
    {
      title: "Failed Consultations",
      value: formatNumber(analyticsData.totalNumberOfFailedConsultations) || 0,
      type: "number"
    }
  ];


  return (
    <>
      {loader}
      <ResponsiveAnalytics
        title="Numerical Analytics"
        data={analyticsCards}
        className="numerical-analytics"
      />
    </>
  );
};

export default NumericalAnalytics;
